var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreview01 = function SvgPreview01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "preview-01_svg2__a",
    x1: 31.68,
    x2: 157.46,
    y1: 168.34,
    y2: 42.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M100 164.17c-42.23.1-80.86-23.82-99.47-61.75-.7-1.5-.7-3.2 0-4.7C27.65 42.68 94.3 20.16 149.24 47.38a111 111 0 0 1 50.24 50.24c.7 1.5.7 3.2 0 4.7-18.61 37.93-57.24 61.85-99.47 61.75v.1Zm-88.77-64.15c25.92 49.04 86.67 67.75 135.7 41.83a100.42 100.42 0 0 0 41.83-41.83c-25.92-49.04-86.67-67.75-135.7-41.83a100.42 100.42 0 0 0-41.83 41.83M100 137.35c-20.62 0-37.33-16.71-37.33-37.33S79.38 62.69 100 62.69s37.33 16.71 37.33 37.33-16.71 37.23-37.33 37.33m0-63.95c-14.71 0-26.62 11.91-26.62 26.62s11.91 26.62 26.62 26.62 26.62-11.91 26.62-26.62S114.71 73.4 100 73.4",
    style: {
      fill: "url(#preview-01_svg2__a)"
    }
  }));
};
export default SvgPreview01;